<template>
  <div class="page">
    <div class="page-content">
  		<page-nav-bar currentServiceName="MoneyRoad" :subNavTitle="attachmentsImport_ImportFile" :returnPreviousPage="isSmartphone"></page-nav-bar>
      <div class="layoutTop"/>
      <div class="container-fluid">
        <div class="row">
        <div class="col-md-10 offset-md-1">
          <div class="panel21 panel-default">
            <h4 class="content-block labelAccordionForm">
                <f7-icon f7="list_bullet"></f7-icon>
                <span v-if="this.service === 'Direct Payments'">
                  {{ $t('attachments.import_refund') }}
                </span>
                <span v-else>
                  {{ $t('attachments.import_invoice') }}
                </span>
            </h4>


          <form>
            <div class="form-group row">
              <label class="col-5 col-sm-2 col-form-label">{{ $t('common.rfrnc') }}</label>
              <div class="col-7 col-sm-10">
                <input class="form-control" name="reference" :placeholder="attachmentsImport_Reference" type="text" v-model="reference"></input>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-5 col-sm-2" v-bind:class="colorBottomButton">
                <div class="button-inner-color fileContainer">
                  {{ $t('common.chse_file') }}
                  <input ref="fileInput" type="file" name="file2" id="file2" @change="onFileChange"></input>
                </div>
              </label>
              <div class="col-7 col-sm-10">
                <input class="form-control" name="filename" :placeholder="attachmentsImport_chseFile" type="text" v-model="attachmentName" disabled></input>
              </div>
            </div>
          </form>

        </div>
      </div>
      </div>
      <div class="row">
        <div class="col-md-2 offset-md-9" v-bind:class="colorBottomButton">
          <button round class="importAttachmentButton button-action firstButtonMarginTop" @click="importAttachment">
            <f7-icon f7="list_bullet"></f7-icon>
            <span>{{ $t('attachments.imprt') }}</span>
          </button>
        </div>
      </div>
      </div>
      <canvas id="pdf-canvas" width="1000" class="hiddenElement"></canvas>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</template>

<script>

import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import Tesseract from 'tesseract.js'
import axios from 'axios'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'importAttachement',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data  () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      tesseract: '',
      typeAttachment: '',
      mimeType: '',
      attachment: '',
      attachmentName: '',
      reference: '',
      newOCRTextData: '',
      service: ''
    }
  },
  created: function () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.attachmentsImport_ImportFile = this.$i18n.t('attachments.import_file')
    this.attachmentsImport_Reference = this.$i18n.t('common.rfrnc')
    this.attachmentsImport_chseFile = this.$i18n.t('common.chse_file')
    this.typeAttachment = ''
    this.mimeType = ''
    this.attachment = ''
    this.attachmentName = ''
    this.reference = ''
    this.fileInput = ''
    this.service = this.$engine.user.currentService.name
    // this.$refs.fileInput.value = null
  },
  methods: {
    importAttachment: function () {
      let that = this
      /* TLV 06/01/2020
      * Lors d'un import le type d'attachment est à présent déterminé par le service
      * Sur les RTP (service vert) --> Invoice
      * Sur les DP (service bleu) --> Refund
      */
      if (this.service === 'Direct Payments') {
        this.typeAttachment = '1'
      } else {
        this.typeAttachment = '0'
      }
      if (that.typeAttachment !== '' && that.attachment !== '' && that.attachmentName !== '') {
        this.$f7.showPreloader('Importing')
        that.$engine.attachments
          .uploadWebapp(
            that.reference,
            this.typeAttachment,
            that.attachment.split(';')[0].split('/')[1],
            that.attachmentName,
            that.attachment,
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            'test',
            ''
          )
          .then(response => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              that.typeAttachment = ''
              that.mimeType = ''
              that.attachment = ''
              that.attachmentName = ''
              that.reference = ''
              that.newOCRTextData = ''
              that.$$(that.$$('#file2')[that.$$('#file2').length - 1]).val('')
              // document.getElementById('file2').value = ''
              that.$bus.$emit('refresh-cache-attachments')
              that.$f7.modal({
                title: 'Attachment imported',
                text: '<span class="preloader"></span>'
              })
              setTimeout(function () {
                that.$f7.closeModal()
                // loadPage(that, {url: '/attachments/', force: false, ignoreCache: false})
                loadPage(that, {url: '/attachments/', ignoreCache: true})
                // that.$f7.mainView.router.back()
                // loadPage(that, {url: '/attachments/'})
              }, 2000)
            }
          })
          .catch(error => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            this.handleError(error) // mixins errorHandlerMixins
          })
        // var pdfData = atob(this.attachment.split(',')[1])
        // var loadingTask = PDFJS.getDocument({data: pdfData})
        // var textDataPromise = loadingTask.promise.then(function (pdf) {
        //   var pageNumber = 1
        //   return pdf.getPage(pageNumber).then(function (page) {
        //     return page.getTextContent().then(function (text) {
        //       return text.items.map(function (s) { return s.str }).join('\n')
        //     })
        //   })
        // }, function (reason) {
        //   console.error(reason)
        // })
        // .catch(error => {
        //   errorMessageAlert(error, that)
        // })
        // textDataPromise.then(function (textData) {
        //   that.$engine.attachments
        //     .uploadWebapp(
        //       that.reference,
        //       0,
        //       that.attachment.split(';')[0].split('/')[1],
        //       that.attachmentName,
        //       that.attachment,
        //       // that.attachment.split(',')[1],
        //       // that.newOCRTextData,
        //       '',
        //       '',
        //       '',
        //       '',
        //       '',
        //       '',
        //       '',
        //       'test',
        //       ''
        //       // document.getElementById('pdf-canvas').toDataURL('image/jpeg', 0.85).replace(/^data:\w+\/\w+;base64,/, '')
        //     )
        //     .then(response => {
        //       that.$f7.closeModal()
        //       that.$f7.hidePreloader()
        //       that.status = response.status
        //       if (response.status === 200) {
        //         that.typeAttachment = ''
        //         that.mimeType = ''
        //         that.attachment = ''
        //         that.attachmentName = ''
        //         that.reference = ''
        //         that.newOCRTextData = ''
        //         that.$$(that.$$('#file2')[that.$$('#file2').length - 1]).val('')
        //         // document.getElementById('file2').value = ''
        //         that.$bus.$emit('refresh-cache-attachments')
        //         that.$f7.modal({
        //           title: 'Attachment imported',
        //           text: '<span class="preloader"></span>'
        //         })
        //         setTimeout(function () {
        //           that.$f7.closeModal()
        //           // loadPage(that, {url: '/attachments/', force: false, ignoreCache: false})
        //           loadPage(that, {url: '/attachments/', ignoreCache: true})
        //           // that.$f7.mainView.router.back()
        //           // loadPage(that, {url: '/attachments/'})
        //         }, 2000)
        //       }
        //     })
        //     .catch(error => {
        //       errorMessageAlert(error, that)
        //     })
        // })
        // .catch(error => {
        //   errorMessageAlert(error, that)
        // })
        // Code OCR
      } else {
        that.$f7.alert('', 'Data missing')
      }
    },
    onFileChange (e) {
      /* eslint-disable no-undef */
      let that = this
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 1000000) {
        that.createImage(files[0])
        that.attachmentName = files[0].name
        that.mimeType = files[0].type
      } else {
        that.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 1MB', 'Maximum file size exceeded')
      }

      // var pdfUrl = URL.createObjectURL(files[0])
      // var canvas = document.getElementById('pdf-canvas')
      // PDFJS.getDocument({ url: pdfUrl })
      // .then(function (pdfDoc) {
      //   pdfDoc.getPage(1)
      //   .then(function (page) {
      //     var scaleRequired = canvas.width / page.getViewport(1).width
      //     var viewport = page.getViewport(scaleRequired)
      //     canvas.height = viewport.height
      //     var renderContext = {
      //       canvasContext: canvas.getContext('2d'),
      //       viewport: viewport
      //     }
      //     page.render(renderContext)
      //     .then(function () {
      //     })
      //   })
      // })
      // TODO: OCR
      // if (that.$engine.settings.get().ocrActivation === '1') {
      //   that.$$(that.$$('.progressbarListItem')[that.$$('.progressbarListItem').length - 1]).show()
      //   that.$$(that.$$('.progressbarContainer')[that.$$('.progressbarContainer').length - 1]).show()
      //   that.$$(that.$$('.importAttachmentButton')[that.$$('.importAttachmentButton').length - 1]).attr('disabled', 'disabled')
      //   var pdfUrl = URL.createObjectURL(files[0])
      //   var canvas = document.getElementById('pdf-canvas')
      //   PDFJS.getDocument({ url: pdfUrl })
      //   .then(function (pdfDoc) {
      //     pdfDoc.getPage(1)
      //     .then(function (page) {
      //       var scaleRequired = canvas.width / page.getViewport(1).width
      //       var viewport = page.getViewport(scaleRequired)
      //       canvas.height = viewport.height
      //       var renderContext = {
      //         canvasContext: canvas.getContext('2d'),
      //         viewport: viewport
      //       }
      //       page.render(renderContext)
      //       .then(function () {
      //         // that.localOCRService()
      //         that.remoteOCRService()
      //         // console.log('----------OK----------')
      //       })
      //     })
      //   })
      // }
      // TODO: OCR
      /* eslint-enable no-undef */
    },
    remoteOCRService () {
      let that = this
      that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text('Recognizing text...')
      axios.post('http://192.168.5.42/character/recognize', {
        method: 'vect+nn',
        preProcess: '',
        language: '',
        whiteList: '',
        pageSegmentationMode: '4',
        imageType: document.getElementById('pdf-canvas').toDataURL('image/jpeg', 0.85).split(';')[0].replace(/^data:/, ''),
        imageBase64: document.getElementById('pdf-canvas').toDataURL('image/jpeg', 0.85).replace(/^data:\w+\/\w+;base64,/, '')
      })
      .then(function (response) {
        // console.log('-----------remoteOCRService-----------')
        // console.log(response.data.text)
        that.newOCRTextData = response.data.text
        that.$$(that.$$('.progressbarContainer')[that.$$('.progressbarContainer').length - 1]).hide()
        that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text('OCR finished !')
        that.$$(that.$$('.importAttachmentButton')[that.$$('.importAttachmentButton').length - 1]).removeAttr('disabled')
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    localOCRService () {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android') {
        Tesseract.workerOptions.workerPath = 'file:///android_asset/www/static/ocr/worker.js'
        Tesseract.workerOptions.langPath = 'file:///android_asset/www/static/ocr/tessdata/'
        Tesseract.workerOptions.corePath = 'file:///android_asset/www/static/ocr/index.js'

        Tesseract.recognize(document.getElementById('pdf-canvas'), {
          lang: 'eng'
        })
        .progress(function (packet) {
          console.info(packet)
          if (packet.status === '') {
          } else if (packet.status === 'loading tesseract core') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), packet.progress * 10)
          } else if (packet.status === 'initializing tesseract') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 10 + packet.progress * 10)
          } else if (packet.status === 'downloading eng.traineddata.gz') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 20 + packet.progress * 10)
          } else if (packet.status === 'unzipping eng.traineddata.gz') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 30 + packet.progress * 10)
          } else if (packet.status === 'loading eng.traineddata') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 40 + packet.progress * 10)
          } else if (packet.status === 'initializing api') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 50 + packet.progress * 10)
          } else if (packet.status === 'recognizing text') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 60 + packet.progress * 40)
          }
          that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text(packet.status)
        })
        .then(function (data) {
          that.newOCRTextData = data.text
          that.$$(that.$$('.progressbarContainer')[that.$$('.progressbarContainer').length - 1]).hide()
          that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text('OCR finished !')
          that.$$(that.$$('.importAttachmentButton')[that.$$('.importAttachmentButton').length - 1]).removeAttr('disabled')
        })
        .catch(error => {
          console.log(error)
        })
      } else if (that.$f7.device.os === 'ios') {
        // Tesseract.workerOptions.workerPath = 'https://cdn.rawgit.com/naptha/tesseract.js/1.0.10/dist/worker.js'
        // Tesseract.workerOptions.langPath = 'https://cdn.rawgit.com/naptha/tessdata/gh-pages/3.02/'
        // Tesseract.workerOptions.corePath = 'https://cdn.rawgit.com/naptha/tesseract.js-core/0.1.0/index.js'
        // TODO
        window.resolveLocalFileSystemURL(cordova.file.applicationDirectory, function (entry) {
          Tesseract.workerOptions.workerPath = entry.nativeURL + 'www/static/ocr/worker.js'
          Tesseract.workerOptions.langPath = entry.nativeURL + 'www/static/ocr/tessdata/'
          Tesseract.workerOptions.corePath = entry.nativeURL + 'www/static/ocr/index.js'

          Tesseract.recognize(document.getElementById('pdf-canvas'), {
            lang: 'eng'
          })
          .progress(function (packet) {
            console.info(packet)
            if (packet.status === '') {
            } else if (packet.status === 'loading tesseract core') {
              that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), packet.progress * 10)
            } else if (packet.status === 'initializing tesseract') {
              that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 10 + packet.progress * 10)
            } else if (packet.status === 'downloading eng.traineddata.gz') {
              that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 20 + packet.progress * 10)
            } else if (packet.status === 'unzipping eng.traineddata.gz') {
              that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 30 + packet.progress * 10)
            } else if (packet.status === 'loading eng.traineddata') {
              that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 40 + packet.progress * 10)
            } else if (packet.status === 'initializing api') {
              that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 50 + packet.progress * 10)
            } else if (packet.status === 'recognizing text') {
              that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 60 + packet.progress * 40)
            }
            that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text(packet.status)
          })
          .then(function (data) {
            that.newOCRTextData = data.text
            that.$$(that.$$('.progressbarContainer')[that.$$('.progressbarContainer').length - 1]).hide()
            that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text('OCR finished !')
            that.$$(that.$$('.importAttachmentButton')[that.$$('.importAttachmentButton').length - 1]).removeAttr('disabled')
          })
        }, function () { console.log('---------error---------') })
      } else {
        Tesseract.workerOptions.workerPath = 'https://cdn.rawgit.com/naptha/tesseract.js/1.0.10/dist/worker.js'
        Tesseract.workerOptions.langPath = 'https://cdn.rawgit.com/naptha/tessdata/gh-pages/3.02/'
        Tesseract.workerOptions.corePath = 'https://cdn.rawgit.com/naptha/tesseract.js-core/0.1.0/index.js'

        Tesseract.recognize(document.getElementById('pdf-canvas'), {
          lang: 'eng'
        })
        .progress(function (packet) {
          console.info(packet)
          if (packet.status === '') {
          } else if (packet.status === 'loading tesseract core') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), packet.progress * 10)
          } else if (packet.status === 'initializing tesseract') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 10 + packet.progress * 10)
          } else if (packet.status === 'downloading eng.traineddata.gz') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 20 + packet.progress * 10)
          } else if (packet.status === 'unzipping eng.traineddata.gz') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 30 + packet.progress * 10)
          } else if (packet.status === 'loading eng.traineddata') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 40 + packet.progress * 10)
          } else if (packet.status === 'initializing api') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 50 + packet.progress * 10)
          } else if (packet.status === 'recognizing text') {
            that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 60 + packet.progress * 40)
          }
          that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text(packet.status)
        })
        .then(function (data) {
          that.newOCRTextData = data.text
          that.$$(that.$$('.progressbarContainer')[that.$$('.progressbarContainer').length - 1]).hide()
          that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text('OCR finished !')
          that.$$(that.$$('.importAttachmentButton')[that.$$('.importAttachmentButton').length - 1]).removeAttr('disabled')
        })
        .catch(error => {
          console.log(error)
        })
      }
      /* eslint-enable no-undef */
    },
    createImage (file) {
      let reader = new FileReader()
      let that = this
      this.$f7.modal({
        title: 'Charging File',
        text: '<span class="preloader"></span>'
      })
      reader.onload = (e) => {
        that.attachment = e.target.result
        that.$f7.closeModal()
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.attachment = ''
    }
  }
}
</script>
<style scoped>
.fileContainer [type=file] {
    display: none;
    color: white;
}
.fileContainer {
  border: 1px solid ;
  text-decoration: none;
  text-align: center;
  border-radius: 27px;
  line-height: 25px;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  padding: 0 10px;
  margin: 0;
  height: 27px;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  outline: 0;
  width: auto;
  float: right;
}
.attachmentImportButtonLength {
  width: 101px;
}
.progressbar {
  height: 8px;
}
.container {
    width: 100%;
    height: auto;
}
.panel2, .panel21 {
    background: #fcfcfc;
    border: solid 1px #dbdbdb;
    /*margin-bottom: 10px;*/
    padding-bottom: 25px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    float: left;
    width: 100%;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
/*
.col-md-offset-3 {
    margin-left: 25%;
    margin-top: 2%;

}*/

 .col-md-12 {
    float: right;
    width: 100%;
    height: auto;
    padding: 0px;
}
.col-md-4 {
  /*float: right;*/
  width: 100%;
  margin: 0px;
}
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 90%
}

.button.button-round {
    border-radius: 27px;
    margin: auto;
}
.panel-heading {
    padding: 10px 15px;
    border-bottom: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    text-transform: uppercase;
}
. {
  width: auto;
}
/*
@media only screen and (max-width: 500px) {
  .panel2, .panel21 {
    width: 100%;
    height: 100%;
    float: left;
  }
  .container {
    height: 100%;
    width: 100%;
  }
}
*/
</style>



// WEBPACK FOOTER //
// CMAttachmentsImport.vue?5c738e5f